import {
    dummyIcons,
    IconGridTemplate,
} from "../../partial-templates/icon-grid/icon-grid.templates";

const dummyLinks = dummyIcons.slice(0, 3).map((item) => ({
    ...item,
    linkText: "Mehr erfahren",
    linkUrl: "#",
}));

export const QuicklinksTemplate = () =>
    IconGridTemplate({
        containerClassName: "ux-u-mt-fluid-s",
        items: dummyLinks,
    });
